<template>
  <div>
    <the-email-header />
    <div class="mt-32">
      <the-user-final-price />
    </div>
  </div>
</template>

<script>
import TheUserFinalPrice from "@/components/email/TheUserFinalPrice.vue";
import TheEmailHeader from "@/components/email/TheEmailHeader.vue";

export default {
  name: "TheEmailTemplate",
  components: {
    TheUserFinalPrice,
    TheEmailHeader,
  },
  data() {
    return {
      showModal: true,
      savedLocale: null,
    };
  },
  created() {
    const { lang } = this.$route.query;
    if (lang) {
      this.savedLocale = this.$i18n.locale;
      this.$i18n.locale = lang;
    }
  },
  unmounted() {
    if (this.savedLocale) {
      this.$i18n.locale = this.savedLocale;
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
